export default __webpack_public_path__ + "static/media/section-1.194f36d2.png";